import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { actionTypes, useStateValue } from "../../../store";
import Header from "../BaseComponents/Header";
import HIFotterMain from "../BaseComponents/Footer";
import {
  getCustomerOrderList,
  GetSellProductByCustomer,
  GetSellProductByCustomerRequestList,
  SellProductByCustomerOTPVerify,
  SellProductByCustomerRequestToMoreDealer,
  SellProductByCustomerToMoreDealer,
} from "../../../networkCalls";
import * as yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import ChatIcon from '@mui/icons-material/Chat';
import LoadingCellFullPage from "../../LoadingCell/LoadingCellFullPage";
import { Alert, Checkbox, FormGroup, Pagination, Tooltip, Typography, Card, TextField } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modal, Button, Table } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useFormik } from "formik";
import { set } from "date-fns";
const MySellProductRequests = () => {
  const { pageSlug } = useParams();
  console.log("pageslug", pageSlug);
  const [show, setShow] = useState(false);
  const [dealer, setDealer] = useState({});
  const [selectedRequest, setSelectedRequest] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setDealer(data);
    setShow(true);
  };
  const [{ token, huid }, dispatch] = useStateValue();
  const [loading, setLoading] = useState(false);
  const [orderlistData, setOrderlistData] = useState([]);

  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [dealererrMessage, setDealerErrMessage] = useState("");
  const [selected, setSelected] = useState([]);

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((d) => d.id !== id.id) : [...prev, id]
    );
  };
  const [Verificationshow, setVerificationShow] = useState(false);


  const checkOrderListData = () => {
    var data = new FormData();
    data.append("customerId", huid);
    data.append("XAuth", token);
    data.append("sellingId", pageSlug);
    setLoading(true);
    GetSellProductByCustomerRequestList(data).then((res) => {
      console.log("data is", res.data);
      setLoading(false);
      switch (res.data.status) {
        case 1:
          //   setPageCount(res?.data?.products?.pagination);
          setOrderlistData(res?.data?.requestList);

          return true;
        case 0:
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  };
  useEffect(() => {
    checkOrderListData();
  }, [token, huid, dispatch, page, pageSlug]);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const navigate = useNavigate();
  const [otpverificationresponse, setOTPverificationRespoanse] = useState("");
  const [dealershow, setdealerShow] = useState(false);
  const [otpshow, setOTPShow] = useState(false);
  const [calculatedPrice, setCalculatedPrice] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const [errMessage, setErrMessage] = useState("");
  // const [dealererrMessage, setDealerErrMessage] = useState("");
  const [susMessage, setSusMessage] = useState("");
  const handleClick = () => {
    var data = new FormData();
    data.append("customerId", huid);
    data.append("XAuth", token);
    data.append("sellingId", pageSlug);
    // setdealerShow(true);
    SellProductByCustomerToMoreDealer(data).then((res) => {
      console.log("data is", res.data);
      // setLoading(false);
      switch (res.data.status) {
        case 1:

          setDealerList(res?.data?.dealerList);
          setdealerShow(true);

          return true;
        case 0:
          setdealerShow(false);
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  }
  const handleSubmitDealerList = () => {
    const dealer = selected.map((val) => {
      return { dealerId: val.dealerid };
    });
    var data = new FormData();
    data.append("customerId", huid);
    data.append("XAuth", token);
    data.append("sellingId", pageSlug);
    data.append("dealerList", JSON.stringify(dealer));
    // setdealerShow(true);
    SellProductByCustomerRequestToMoreDealer(data).then((res) => {
      console.log("data is", res.data);
      // setLoading(false);
      switch (res.data.status) {
        case 1:

          // setDealerList(res?.data?.dealerList);
          setdealerShow(false);
          setOTPShow(true);

          return true;
        case 0:
          setdealerShow(false);
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
    // setdealerShow(true);
  }
  const validationSchema2 = yup.object({
    otp: yup
      .string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .length(6, "OTP must be 6 digits")
      .required("OTP is required"),
  });
  // const [otpverificationresponse, setOTPverificationRespoanse] = useState("");

  const formikOtpVerify = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema2,
    onSubmit: (values) => {
      console.log("values", values);
      var data = new FormData();
      data.append("customerId", huid);
      data.append("XAuth", token);
      data.append("otp", values.otp);
      data.append("sellingId", pageSlug);
      SellProductByCustomerOTPVerify(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            // setSellingId(res.data.sellingId);
            setOTPShow(false);
            // setChangetoOTP(false);
            // setdealerShow(true);
            console.log("response ", res.data.msz);
            setOTPverificationRespoanse(res.data.msz);
            setVerificationShow(true);
            // navigate("/myaccount/sell-your-product");

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
      // setChangetoOTP(true);
    },
  });
  return (
    <>
      <Header />
      {loading ? (
        <>
          <LoadingCellFullPage />
        </>
      ) : (
        <>
          <div className="innerpagebg pt-5 pb-5">
            <div className="container">
              <div className="d-flex flex-column flex-lg-row flex-md-row align-items-start align-items-lg-center  align-items-md-center  gap-2 gap-lg-5 gap-md-5 w-100 hitableheaderheading">
                <div>

                  <Link
                    to="/myaccount/sell-your-product"
                    className=" d-flex gap-3 text-black "
                  >
                    {" "}
                    <ArrowBackIcon /> My Products
                  </Link>
                </div>

                <div className="d-flex align-items-center justify-content-between w-100 w-lg-75 w-md-75">
                  <h4 className=" text-center m-0 fw-bold text-uppercase hitableheaderheading">
                    <span className="texthivalueplus">My </span>{" "}
                    <span className="txtdgray">
                      Product's Requests ({orderlistData?.length})
                    </span>
                  </h4>
                  <div className="d-block mt-0 mt-lg-3 mt-md-3 hitableheaderheading fw-bold txtHiPrimaryColor pointer" onClick={handleClick} >+ Send More Request</div>
                </div>

              </div>
            </div>
            <div className="container  mt-0 mt-lg-3 mt-md-3">
              <div className="row">
                <div className="col-lg-9 col-md-12 col-12 m-auto">
                  {
                    <div class="table-responsive  mt-2 mt-lg-3 mt-md-3">
                      <table class="table table-bordered table-striped">
                        <thead class="hitablehead">
                          <tr>
                            <th>Model Name</th>
                            <th>Dealer Name</th>
                            <th>Request Status</th>
                            <th>View Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderlistData.map((val, id) => {
                            return (
                              <tr key={id} className="hitablebodytext ">
                                <td className="texthivalueplus fw500">
                                  {val.productName}
                                </td>
                                <td>{val.dealerName}</td>
                                <td>{val.requestStatusLabel}</td>
                                <td >
                                  <div className="d-flex align-items-center gap-2">
                                    {
                                      val?.requestComment !== null && val?.requestComment !== "" && (
                                        <Tooltip
                                          title="View Comments"
                                          placement="left"
                                          arrow
                                        >
                                          <Link
                                            className="text-black"
                                            onClick={() => {
                                              handleShow(val);
                                              setSelectedRequest("comments");
                                            }}
                                            to="#"
                                          >
                                            <ChatIcon className="hitablebodytext" />{" "}
                                          </Link>
                                        </Tooltip>)
                                    }
                                    {val?.requestStatus === 1 && (
                                      <Tooltip
                                        title="View Details"
                                        placement="right"
                                        arrow
                                      >
                                        <Link
                                          className="text-black"
                                          onClick={() => {
                                            handleShow(val);
                                            setSelectedRequest("details");
                                          }}
                                          to="#"
                                        >
                                          <VisibilityIcon className="hitablebodytext" />{" "}
                                        </Link>
                                      </Tooltip>
                                    )}</div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  }
                </div>
                {/* <div className="col-lg-9 col-md-12 col-12 d-flex justify-content-center m-auto">
                  <Pagination
                    color="error"
                    variant="outlined"
                    // shape="rounded"
                    count={pageCount}
                    page={page}
                    onChange={handleChange}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#0873bb", // text color for unselected
                        borderColor: "#0873bb", // border for outlined variant
                        "&:hover": {
                          backgroundColor: "rgba(8, 115, 187, 0.1)", // light blue hover
                        },
                      },
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#0873bb", // ✅ your base color for active background
                        color: "#fff", // white text
                        borderColor: "#0873bb",
                        "&:hover": {
                          backgroundColor: "#065f99", // slightly darker on hover
                          borderColor: "#065f99",
                        },
                      },
                    }}
                  />
                </div> */}
              </div>
            </div>
          </div>
        </>
      )}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedRequest ==="details" ?  "Dealer Details": "Dealer Comments"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedRequest ==="details" ? <div className="col-12 mb-1 f12">
            <h6 className="mb-2 texthivalueplus fw-semibold">
              {dealer?.dealerName}
            </h6>
            <div>
              <span className="fw-bold">Address : </span>
              {dealer?.address1}, {dealer?.address2}, {dealer?.address3},{" "}
              {dealer?.city}, {dealer?.state}
            </div>
            <div>
              <span className="fw-bold">Pin Code : </span>
              {dealer?.pincode}
            </div>
            {dealer?.email && dealer?.email != "" ? (
              <div>
                <span className="fw-bold">Email : </span>
                {dealer?.email}
              </div>
            ) : (
              <></>
            )}
            {dealer?.phone && dealer?.phone != "" ? (
              <div>
                <span className="fw-bold">Phone : </span>
                {dealer?.phone}
              </div>
            ) : (
              <></>
            )}
            {/* <hr className='mt-1 mb-1' /> */}
          </div> : <div className="col-12 mb-1 f16 ">
            {dealer?.requestComment}
          </div>}
        
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Dealer list modal  */}
      <Modal
        size="lg"
        show={dealershow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => {
          setdealerShow(false);
        }}
        aria-labelledby="video-lg"
      >
        <Modal.Header closeButton className="  mx-4 mt-2  px-0">
          <span className="hivalueplusmodalheader">Dealer’s List</span>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="px-3 mt-2">
            <div className="row">
              <form
                className="col-12"
                // onSubmit={handleSubmitDealerList}
                autoComplete="off"
              >
                <div className="overflow-auto" style={{ maxHeight: "400px" }}>
                  <FormGroup>
                    {dealerList.map((dealer) => {
                      const isSelected = selected.includes(dealer);

                      return (
                        <Card
                          key={dealer.dealerid}
                          variant=""
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1.5,
                            paddingRight: 2,
                            paddingLeft: 2,
                            marginBottom: 1,
                            // p: 0 2 0 2,
                            // mb: 2,
                          }}
                        >
                          {/* Checkbox */}
                          <Checkbox
                            checked={isSelected}
                            onChange={() => handleSelect(dealer)}
                            sx={{
                              color: "grey.400",
                              "&.Mui-checked": { color: "primary.main" },
                              alignSelf: "flex-start",
                            }}
                          />

                          {/* Dealer Info */}
                          <Card
                            variant="outlined"
                            sx={{
                              // border: "gray",
                              borderRadius: 2,
                              borderWidth: 2,
                              p: 1,

                              borderColor: isSelected
                                ? "primary.main"
                                : "grey.300",
                              boxShadow: isSelected ? 3 : 0,
                              transition: "0.2s",
                              flexGrow: 1,
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: "bold",
                                color: "#0873bb",
                                mb: 0.3,
                                textTransform: "uppercase",
                              }}
                            >
                              {dealer.dealerName}
                            </Typography>

                            <Typography sx={{ mb: 0.3, fontSize: "12px" }}>
                              <strong>Address:</strong> {dealer.dealerAddress2}{" "}
                              {dealer.dealerAddress3} {dealer.dealerAddress4} ,
                              {dealer.dealerState} ,{dealer.dealerCity}
                            </Typography>
                            <Typography sx={{ mb: 0.3, fontSize: "12px" }}>
                              <strong>Pin Code:</strong> {dealer.dealerPinCode}
                            </Typography>
                          </Card>
                        </Card>
                      );
                    })}
                  </FormGroup>
                </div>
                {dealererrMessage !== "" ? (
                  <Alert className="text-center" severity="error">
                    {dealererrMessage}
                  </Alert>
                ) : null}
                <div className="col-lg-12 col-12">
                  <div className="relative w-full d-flex justify-content-center mb-3 mt-3">
                    <Button
                      variant="contained"
                      className="hivalueplusSubmitBtn"
                      // type="submit"
                      onClick={() => {
                        if (selected.length > 0) {
                          // setShow(true);
                          handleSubmitDealerList();
                          // setdealerShow(false);
                        } else {
                          setDealerErrMessage(
                            "Please Select atleast one dealer"
                          );
                        }
                      }}
                    >
                      Select & Next
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Dealer list modal  */}

      <Modal
        size="md"
        show={otpshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => setOTPShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => setOTPShow(false)}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="px-5 m-5">
            <div className="row">
              <div className="col-12">
                <h4 className=" m-0 fw-bold text-uppercase text-center">
                  <span className="txtdgray">OTP Verification</span>
                </h4>
              </div>

              <form
                className="col-12"
                onSubmit={formikOtpVerify.handleSubmit}
                autoComplete="off"
              >
                <div>
                  <div className="mt-3">
                    <TextField
                      className="mb-4 w-100"
                      variant="standard"
                      id="otp"
                      name="otp"
                      label="Enter 6 digit code *"
                      type="text"
                      value={formikOtpVerify.values.otp}
                      onChange={formikOtpVerify.handleChange}
                      onBlur={formikOtpVerify.handleBlur}
                      error={
                        formikOtpVerify.touched.otp &&
                        Boolean(formikOtpVerify.errors.otp)
                      }
                      helperText={
                        formikOtpVerify.touched.otp &&
                        formikOtpVerify.errors.otp
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-12 col-12">
                  <div className="relative w-full mb-3">
                    <Button
                      variant="contained"
                      className="w-100 hivalueplusSubmitBtn"
                      type="submit"
                    // onClick={() => {
                    //   setShow(true);
                    // }}
                    >
                      Verify
                    </Button>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={Verificationshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => setVerificationShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => setVerificationShow(false)}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="px-5 m-5">
            <div className="row">
              {/* <div className="col-12">
                            <h4 className=" m-0 fw-bold text-uppercase text-center">
                              <span className="txtdgray">OTP Verification</span>
                            </h4>
                          </div> */}
              <div className="col-12 txtdgray text-center py-4">
                {otpverificationresponse}
              </div>
              <div className="col-12 d-flex justify-content-center mt-2">
                <div
                  className="hivalueplussectionBtn d-flex justify-content-center align-items-center p-2"
                  style={{ width: "120px" }}
                  onClick={() => {
                    setVerificationShow(false);
                    checkOrderListData();

                    // navigate("/myaccount/sell-your-product");
                  }}
                >
                  OK
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      <HIFotterMain />
    </>
  );
};

export default MySellProductRequests;
